import { render } from "./TicketsStatusChart.vue?vue&type=template&id=75eed956&ts=true"
import script from "./TicketsStatusChart.vue?vue&type=script&lang=ts"
export * from "./TicketsStatusChart.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__